import { render, staticRenderFns } from "./terms_h5.vue?vue&type=template&id=0175bec7&scoped=true"
import script from "./terms_h5.vue?vue&type=script&lang=js"
export * from "./terms_h5.vue?vue&type=script&lang=js"
import style0 from "./terms_h5.vue?vue&type=style&index=0&id=0175bec7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0175bec7",
  null
  
)

export default component.exports